import {
  isLoaded,
  brands,
  categories,
  subCategories,
  years,
  seasons,
  markets,
  channels,
  countries,
  divisions,
  departments,
  vendors,
  mills,
  vendorGroups,
  searchCriteria
} from './definition'

import _ from 'lodash'

const sortByName = (list) => {
  return list.sort((a, b) => {
    if (a.name < b.name) {
      return -1
    } else if (a.name > b.name) {
      return 1
    } else {
      return 0
    }
  })
}

export default {
  [isLoaded] (state, value) {
    state.isLoaded = value
  },
  [brands] (state, value) {
    state.brands = sortByName(value)
  },
  [categories] (state, value) {
    state.categories = sortByName(value)
  },
  [subCategories] (state, value) {
    state.subCategories = sortByName(value)
  },
  [years] (state, value) {
    state.years = value
  },
  [seasons] (state, value) {
    state.seasons = value
  },
  [markets] (state, value) {
    state.markets = sortByName(value)
  },
  [channels] (state, value) {
    state.channels = sortByName(value)
  },
  [countries] (state, value) {
    state.countries = sortByName(value)
  },
  [divisions] (state, value) {
    state.divisions = sortByName(value)
  },
  [departments] (state, value) {
    state.departments = sortByName(value)
  },
  [vendors] (state, value) {
    state.vendors = sortByName(_.uniqBy(value, 'code'))
  },
  [mills] (state, value) {
    state.mills = sortByName(value)
  },
  [vendorGroups] (state, value) {
    state.vendorGroups = value
    // state.vendorGroups = sortByName(_.uniqBy(value, 'code'))
  },
  [searchCriteria] (state, { field, value }) {
    state.searchCriteria[field] = value
  }
}



// WEBPACK FOOTER //
// ./src/components/common/store/mutations.js